import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  isAdmin: false,
  initialized: false, // Used to know if we've finished checking tokens on app startup
  accessToken: localStorage.getItem("authToken") || null,
  userProfile: JSON.parse(localStorage.getItem("userProfile")) || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload;
      // state.isAuthenticated = true;
    },
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.isAdmin = !!action.payload.is_admin;
    },
    setUserProfile(state, action) {
      state.userProfile = action.payload;
      localStorage.setItem("userProfile", JSON.stringify(action.payload));
    },
    logout(state) {
      state.accessToken = null;
      state.userProfile = null;
      state.isAdmin = false;
      state.isAuthenticated = false;
      localStorage.removeItem("authToken");
    },
    setInitialized(state) {
      state.initialized = true;
    },
  },
});

export const {
  loginSuccess,
  setUserProfile,
  logout,
  setAccessToken,
  setInitialized,
} = authSlice.actions;
export default authSlice.reducer;
